import { apiClient } from './client';
import { unwrapAndTransform } from '../utils/api-response';
// ---------------------------------------------------------------------------
// All unwrapping now handled by unwrapAndTransform
// Eliminates: manual response.data.data unwrapping pattern
// ---------------------------------------------------------------------------
export const personalityApi = {
    // Get user's personality analyses
    getUserAnalyses: async (userId) => {
        const response = await apiClient.get(`/v1/admin/users/${userId}/personality`);
        return unwrapAndTransform(response);
    },
    // Get latest personality analysis
    getLatestAnalysis: async (userId) => {
        const response = await apiClient.get(`/v1/admin/users/${userId}/personality/latest`);
        return unwrapAndTransform(response);
    },
    // Get personality insights
    getInsights: async (userId) => {
        const response = await apiClient.get(`/v1/admin/users/${userId}/insights`);
        return unwrapAndTransform(response);
    },
    // Get user matches
    getMatches: async (userId) => {
        const response = await apiClient.get(`/v1/admin/users/${userId}/matches`);
        return unwrapAndTransform(response);
    },
    // Trigger personality analysis
    triggerAnalysis: async (userId) => {
        await apiClient.post(`/v1/admin/users/${userId}/analyze`);
    },
    // Get personality analytics
    getAnalytics: async () => {
        const response = await apiClient.get('/v1/admin/analytics/personality');
        return unwrapAndTransform(response);
    },
};
